<template>
  <layout-main-inner title="报名抽奖">
    <el-button
      slot="action"
      type="primary"
      @click="addLottery">新增</el-button>
    <layout-card-wrap hasHeaderSlot>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0">
        <el-form-item>
          <el-radio-group
            v-model="config.status"
            @change="handleCurrentChange(1)">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="0">待上线</el-radio-button>
            <el-radio-button :label="1">进行中</el-radio-button>
            <el-radio-button :label="2">已结束</el-radio-button>
            <el-radio-button :label="3">已关闭</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-table
        border
        default-expand-all
        :data="list">
        <el-table-column
          label="活动名称"
          :resizable="false">
          <template slot-scope="{ row }">{{ row.lotteryName }}</template>
        </el-table-column>
        <el-table-column
          label="活动描述"
          :resizable="false"
          prop="lotteryRule"></el-table-column>
        <el-table-column
          label="商品"
          :resizable="false"
          prop="prize.goodsName"></el-table-column>
        <el-table-column
          label="奖品数量"
          :resizable="false"
          width="110">
          <template slot-scope="{ row }">{{ row.winningCount }}件</template>
        </el-table-column>
        <el-table-column
          label="报名人数(已/总)"
          :resizable="false"
          width="110">
          <template slot-scope="{ row }">{{ row.drawCount || 0 }}/{{ row.count }}</template>
        </el-table-column>
        <el-table-column
          label="活动状态"
          width="80"
          :resizable="false">
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.status === 0"
              type="info">待上线</el-tag>
            <el-tag
              v-if="row.status === 1"
              type="success">进行中</el-tag>
            <el-tag
              v-if="row.status === 2"
              type="warning">已结束</el-tag>
            <el-tag
              v-if="row.status === 3"
              type="danger">已关闭</el-tag>
            <el-tag
              v-if="row.status === 9"
              type="danger">已取消</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="开奖时间"
          width="140">
          <template slot-scope="{ row }">
            <div v-if="row.status !== 0">
              <!-- <span>{{ row.startTime | dateformat() }}</span>
              - -->
              <span>{{ row.closeTime | dateformat() }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="操作"
          width="200">
          <template slot-scope="{ row, $index }">
            <el-popover
              v-show="row.status === 0"
              :key="$index"
              :ref="`popover_${$index}`"
              title="选择开奖时间"
              trigger="click"
              placement="right"
            >
              <div style="margin:10px">
                <el-date-picker
                  v-model="row.closeTimeBak"
                  type="datetime"
                  :picker-options="pickerOptions"
                  placeholder="选择开奖时间"
                ></el-date-picker>
                <div style="margin-top:10px;text-align:right">
                  <el-button
                    type="primary"
                    @click="
                      () => {
                        publishLottery(row, `popover_${$index}`)
                      }
                    "
                  >
                    确定
                  </el-button>
                </div>
              </div>
              <el-button
                slot="reference"
                style="margin-right:10px"
                type="primary">上线</el-button>
            </el-popover>
            <el-dropdown>
              <el-button type="info">
                更多
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.status === 0"
                  @click.native="editLottery(row)">编辑</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status === 0"
                  @click.native="deleteLottery(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status === 1 || row.status === 2"
                  @click.native="closeottery(row)">
                  关闭
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status !== 0"
                  @click.native="viewRecords(row)">中奖记录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button
              v-if="row.status===0"
              type="text"
              style="margin-left:10px"
              @click="editLottery(row)">编辑</el-button>
            <el-button
              v-if="row.status===0"
              type="text"
              @click="deleteLottery(row)">删除</el-button>
            <el-button
              v-if="row.status===1 || row.status===2"
              type="text"
              @click="closeottery(row)">关闭</el-button>
            <el-button
              v-if="row.status!==0"
              type="text"
              @click="viewRecords(row)">中奖记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
      <lottery-reg-modal
        ref="modal"
        :callback="fetchList" />
      <winning-records-modal ref="records" />
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import LotteryRegModal from '../busi/draw-reg-modal.vue'
// import LotteryGoodsInfo from '../busi/lottery-goods-info.vue'
import WinningRecordsModal from '../busi/winning-records-modal.vue'
// import moment from 'moment'
export default {
  name: 'LotteryList',
  components: { LotteryRegModal, WinningRecordsModal },
  data() {
    return {
      loading: true,
      pickerOptions: {
        disabledDate: date => {
          return date < Date.now()
        }
      },
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        status: null,
        lotteryType: 8
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    viewRecords(row) {
      this.$refs.records.fetch(row)
    },
    addLottery() {
      this.$refs.modal.toggleModal(true)
    },
    editLottery(row) {
      this.$refs.modal.fetch({
        vendorId: row.vendorId,
        lotteryId: row.lotteryId
      })
    },
    closeottery(row) {
      this.$confirm('您确定关闭该报名抽奖活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('lottery/closelottery', {
          payload: {
            vendorId: row.vendorId,
            lotteryId: row.lotteryId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    deleteLottery(row) {
      this.$confirm('您确定删除该报名抽奖活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('lottery/deletelottery', {
          payload: {
            vendorId: row.vendorId,
            lotteryId: row.lotteryId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    publishLottery(row) {
      console.log(row)
      if (!row.closeTimeBak) {
        this.$message.error('请选择时间')
        return
      }
      this.$confirm('您确定发布该报名抽奖活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch(`lottery/publishlottery`, {
          payload: {
            vendorId: row.vendorId,
            lotteryId: row.lotteryId,
            startTime: +Date.now(),
            closeTime: +row.closeTimeBak
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('lottery/getlotterys', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            i.closeTimeBak = i.closeTime
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
